<template>
  <fragment>
    <tr @click="eventoclick()">
      <td>
        <v-switch v-model="check" class="switch-base" />
      </td>
      <td class="plano-cel">
        <div>
          <strong>{{nome}}</strong>
          <br />
          <small>{{regiao}}</small>
        </div>
      </td>
      <td rowspan="2">
        <a class="price">
          <div v-if="preco">
            {{preco}}
            <br />
            <label class="copay">{{coparticipacao}}</label>
          </div>
          <div v-else>
            Não Possui
            <br />
            <label class="copay">{{coparticipacao}}</label>
          </div>

          <div v-if="preco2">
            {{preco2}}
            <br />
            <label class="copay">{{coparticipacao2}}</label>
          </div>
          <div v-else>
            Não Possui
            <br />
            <label class="copay">{{coparticipacao2}}</label>
          </div>
        </a>
      </td>
    </tr>
    <tr>
      <td>
        <small>{{acomodacao}}</small>
      </td>
      <td class="plano-cel">
        <div>
          <small>{{segmentacao}}</small>
        </div>
      </td>
      <td></td>
    </tr>
    <tr>
      <td colspan="3">
        <hr />
      </td>
    </tr>
  </fragment>
</template>

<script>
import { Fragment } from "vue-fragment";
export default {
  components: { Fragment },
  props: [
    "nome",
    "preco",
    "preco2",
    "check",
    "segmentacao",
    "acomodacao",
    "coparticipacao",
    "coparticipacao2",
    "regiao",
  ],
  methods: {
    eventoclick() {
      this.$emit("evento");
    },
  },
};
</script>
<style>
.plano-cel {
  padding-left: 18% !important;
}

.dataText {
  text-transform: capitalize;
}

.planoLine {
  border-bottom: 1px solid var(--v-border-base);
}

.price {
  text-align: right;
}

.copay,
.segmentacao {
  color: var(--v-foreground-base);
  font-size: 10px;
  vertical-align: top;
}

@media screen and (max-width: 500px) {
  .plano-cel {
    padding-left: 5% !important;
    padding-right: 3% !important;
  }
}

@media screen and (max-width: 680px) {
  .copay {
    font-size: 9.5px;
  }
}
</style>
